import { Injectable, inject } from '@angular/core';

import { BetBuilderFixture } from '@cds/betting-offer/domain-specific/bet-builder';
import { PopularBetsOptionTeamInfo } from '@cds/betting-offer/domain-specific/popular-bets';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { PopularBetsPodTypes } from '@frontend/sports/types/components/popular-bets';

import { BetBuilderOptionType, IPreCreatedOption } from '../popular-bets.models';
import { PopularBetsPodEventLogoService } from './popular-bets-pod-event-logo.service';
import { PopularBetsPodEventParticipantService } from './popular-bets-pod-event-participant.service';
import { PopularBetsPodOptionService } from './popular-bets-pod-option.service';

@Injectable({
    providedIn: 'root',
})
export class PopularBetsBetBuilderDataService {
    private optionService = inject(PopularBetsPodOptionService);
    private eventLogoService = inject(PopularBetsPodEventLogoService);
    private participantService = inject(PopularBetsPodEventParticipantService);

    getPreCreatedOptions(
        offer: BetBuilderFixture,
        events: GridEvent[],
        podType: PopularBetsPodTypes,
        optionTeamInfo: PopularBetsOptionTeamInfo[],
    ): IPreCreatedOption[] {
        const { precreatedGroupedInfo, sourceFixture } = offer;
        const precreatedOptions = precreatedGroupedInfo[0].options;
        const event = events.find((event) => event.id === offer.sourceId)!;

        const eventOptionMap: { [id: number]: EventOption } = {};
        event.optionGroups.forEach((group) => {
            group.options.forEach((option) => {
                eventOptionMap[option.id] = option;
            });
        });

        const options: IPreCreatedOption[] = [];
        for (const precreatedOption of precreatedOptions) {
            for (const optionMarket of sourceFixture.optionMarkets) {
                const currentOption = optionMarket.options.find((option) => option.id === precreatedOption.id);
                if (!currentOption) continue;
                const eventOption = eventOptionMap[currentOption.id];

                options.push({
                    name: this.optionService.getOptionMarketName(optionMarket.name.value, currentOption.name.value, podType),
                    optionId: currentOption.id,
                    fixtureId: offer.sourceId,
                    opponentParticipant: this.participantService.getOpponentParticipantFromOption(eventOption, event, optionTeamInfo),
                    logoDetails: this.eventLogoService.getLogoDetailsForPodEvent(eventOption, event, podType, optionTeamInfo),
                    type: BetBuilderOptionType.Group,
                });
            }
        }

        return options;
    }

    getPreCreatedMarkets(offer: BetBuilderFixture, events: GridEvent[], podType: PopularBetsPodTypes): IPreCreatedOption[] {
        const { sourceFixture } = offer;
        const event = events.find((event) => event.id === offer.sourceId)!;
        const eventOption = event.optionGroups[0].options[0];

        return sourceFixture.optionMarkets[0].name.value.split(';').map((optionName) => ({
            name: optionName,
            optionId: 0,
            fixtureId: offer.sourceId,
            opponentParticipant: this.participantService.getOpponentParticipantFromOption(eventOption, event),
            logoDetails: this.eventLogoService.getLogoDetailsForPodEvent(eventOption, event, podType),
            type: BetBuilderOptionType.Market,
        }));
    }
}
